import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4340aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "profile_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "英語力", -1))
const _hoisted_6 = { class: "profile_item_value" }
const _hoisted_7 = { class: "profile_item_value_text" }
const _hoisted_8 = { class: "profile_item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "その他言語", -1))
const _hoisted_10 = { class: "profile_item_value" }
const _hoisted_11 = { class: "profile_button_register" }
const _hoisted_12 = { class: "profile_button_modify" }

import { ref, Ref, computed } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkillLanguageConfirmView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isLoading = ref(false);

// 言語情報取得
const engsklId: number = store.getters['careerSheetLanguage/engsklId'];
const otrlang1Id: number | null = store.getters['careerSheetLanguage/otrlang1Id'];
const otrlang2Id: number | null = store.getters['careerSheetLanguage/otrlang2Id'];
const otrlang3Id: number | null = store.getters['careerSheetLanguage/otrlang3Id'];

// 言語マスタ取得
const mstLangSklObject = computed(() => store.getters['master/mstListLanguageObject']);
const mstOtrLangSklObject = computed(() => store.getters['master/mstListOtrLanguageObject']);

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e55', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e55' });
  }
};

const engskl = computed(() => {
  if (!engsklId) return '';
  return mstLangSklObject.value[engsklId];
});

const otrlang1 = computed(() => {
  if (!otrlang1Id) return '';
  return mstOtrLangSklObject.value[otrlang1Id];
});
const otrlang2 = computed(() => {
  if (!otrlang2Id) return '';
  return mstOtrLangSklObject.value[otrlang2Id];
});
const otrlang3 = computed(() => {
  if (!otrlang3Id) return '';
  return mstOtrLangSklObject.value[otrlang3Id];
});

const otrlangSkillArray: Ref<string[]> = ref([]);
otrlangSkillArray.value = [otrlang1.value, otrlang2.value, otrlang3.value];

const save = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('careerSheetLanguage/putLangSkill');
    store.dispatch('toasts/appendTimeToast', { label: '言語を更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e50', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n50' });
    }
  } catch (error) {
    store.dispatch('toasts/appendTimeToast', { label: '言語の更新に失敗しました', duration: null });
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(engskl)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otrlangSkillArray.value, (otrlangSkill) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "profile_item_value_text",
            key: otrlangSkill
          }, _toDisplayString(otrlangSkill), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(BaseButton, {
        theme: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("この内容で決定する")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(BaseButton, {
        theme: "secondary",
        onClick: transitionPreviousPage
      }, {
        default: _withCtx(() => [
          _createTextVNode("修正する")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})